



import { Component } from 'vue-property-decorator';
import Important from "@/components/important/main/important.vue";
import {myVue} from "@/components/class/myVue";
export default class HelloWorld extends myVue {
}
